import { render, staticRenderFns } from "./sixHeader.vue?vue&type=template&id=08f48a63&scoped=true&"
import script from "./sixHeader.vue?vue&type=script&lang=js&"
export * from "./sixHeader.vue?vue&type=script&lang=js&"
import style0 from "./sixHeader.vue?vue&type=style&index=0&id=08f48a63&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f48a63",
  null
  
)

export default component.exports